// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_fluentui_font-icons-mdl2_lib_index_js-node_modules_fluentui_react-file-t-0f2e96":"1e1d1591a8782c9bbee7","src_taskpane_App_js":"9fd573e6b4dc99e8a54d"}[chunkId] + ".js";
};